import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Donation from "../components/Donation";

export default withRouter(connect()(Donation));
